import { Paper, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { Tag } from "../models/tag"

interface Props {
  tag: Tag
}

export default function TagDetailContent({ tag }: Props) {
  const { t } = useTranslation()

  return (
    <Stack p="md">
      <Paper withBorder p="sm" radius="md">
        <Text size="xs" tt="uppercase" c="dimmed">
          {t("tags.name")}
        </Text>
        <Text>{tag.name}</Text>
      </Paper>
      <Paper withBorder p="sm" radius="md">
        <Text size="xs" tt="uppercase" c="dimmed">
          {t("tags.order")}
        </Text>
        <Text>{tag.order}</Text>
      </Paper>
    </Stack>
  )
}
